<template>
  <main-layout :selectedMenu="'myHome'">
    <div class="cancelBox" :style="{ height: height + 'px' }">
      <div class="box1" v-if="type == 1">
        <div class="title1">{{ $t("works.注销账号") }}</div>
        <div class="title2">{{ $t("works.MANA账号注销后不可恢复") }}</div>
        <div class="title3">
          {{ $t("works.你的私有数据将被") }}<i>{{ $t("works.永久删除") }}</i
          >，{{ $t("works.建议做好备份") }}
        </div>
        <div class="title4">
          <span class="text1" @click="goNext">{{ $t("works.继续注销") }}</span>
          <span class="text2" @click="gotoManage">{{
            $t("works.返回个人中心")
          }}</span>
        </div>
      </div>
      <div class="box2" v-if="type == 2">
        <div class="title">{{ $t("works.说一下注销的原因吧") }}</div>
        <div class="radio">
          <div class="name" v-for="(item, i) in list" :key="i">
            <span
              @click="selectName(item.id)"
              :class="[reasonId === item.id ? 'active' : '']"
              ><i></i></span
            >{{ language === "zh" ? item.reason : item.enReason || item.reason
            }}<a :href="item.linkUrl" v-if="item.linkText"
              >{{
                language === "zh"
                  ? item.linkText
                  : item.enLinkText || item.linkText
              }} >></a
            >
          </div>
          <div class="name">
            <span
              @click="selectName(999)"
              :class="[reasonId === 999 ? 'active' : '']"
              ><i></i></span
            >{{ $t("works.其他原因（请填写）") }}：<input
              type="text"
              v-model="reason"
              :disabled="reasonId === 999 ? false : true"
              :placeholder="$t('works.填写理由示例')"
            />
          </div>
        </div>
        <div class="title4">
          <span class="text1" @click="goNext1">{{ $t("global.下一步") }}</span>
          <span class="text2" @click="gotoManage">{{
            $t("works.返回个人中心")
          }}</span>
        </div>
      </div>
      <div class="box3" v-if="isShow">
        <div class="bussBox">
          <img src="https://image.manamana.net/1635304428000_fWMwKvql" alt="" />
          <div class="title1">{{ $t("works.注销成功") }}</div>
          <div class="title2">
            {{ times + "s" }}{{ $t("works.后自动返回首页") }}
          </div>
        </div>
      </div>
    </div>
  </main-layout>
</template>
<script>
import MainLayout from "@/layouts/MainLayout";

export default {
  name: "cancel",
  metaInfo() {
    return {
      title: this.$t("works.注销账号") + " | MANA",
    };
  },
  data() {
    return {
      height: 0,
      type: 1,
      reason: "",
      reasonId: null,
      isShow: false,
      times: 3,
      list: [],
    };
  },
  components: {
    MainLayout,
  },
  created() {
    this.getReason();
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.height = document.documentElement.clientHeight - 66 - 160;
      }, 50);
    });
  },
  computed: {
    peopleMessage() {
      return this.$store.state.peopleMessage;
    },
    language() {
      return this.$language();
    },
  },
  methods: {
    getReason() {
      this.$http.get("/api/common/close/reason").then((res) => {
        if (res.code === "OK") {
          this.list = res.data;
        }
      });
    },
    goNext() {
      this.type = 2;
    },
    goNext1() {
      if (this.reasonId) {
        let params = {
          otherReason: this.reason,
          reasonId: this.reasonId == 999 ? null : this.reasonId,
          userId: this.peopleMessage.userId,
        };
        if (this.peopleMessage.userId) {
          this.$http
            .post("/api/passport/user/close", params, {
              headers: {
                "Content-Type": "application/json",
              },
            })
            .then((res) => {
              if (res.code === "OK") {
                localStorage.removeItem("auth_token");
                localStorage.removeItem("isLogin");
                localStorage.removeItem("userId");
                this.$store.dispatch("restUser");
                localStorage.setItem("isLogin", "false");
                this.isShow = true;
                var times = setInterval(() => {
                  if (this.times <= 0) {
                    clearInterval(times);
                    this.$router.replace("/");
                  } else {
                    this.times--;
                  }
                }, 1000);
              }
            });
        } else {
          this.$router.push("/login");
        }
      } else {
        this.$message(this.$t("works.请选择注销原因！"));
      }
    },
    gotoManage() {
      this.$router.go(-1);
    },
    selectName(id) {
      this.reasonId = id;
    },
  },
};
</script>
<style lang="stylus" scoped>
.cancelBox {
  padding-top: 60px;
  padding-left: 18%;
  box-sizing: border-box;
  min-height: 635px;

  .box1 {
    .title1 {
      height: 36px;
      font-size: 24px;
      font-weight: 600;
      color: #333333;
      line-height: 36px;
    }

    .title2 {
      height: 21px;
      font-size: 14px;
      font-weight: 400;
      color: #333333;
      line-height: 21px;
      margin: 32px 0 16px 0;
    }

    .title3 {
      height: 21px;
      font-size: 14px;
      font-weight: 400;
      color: #333333;
      line-height: 21px;

      i {
        color: #FE5630;
      }
    }

    .title4 {
      margin-top: 40px;

      .text1 {
        display: inline-block;
        width: 136px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        background: #2026CC;
        font-size: 16px;
        font-weight: 600;
        color: #FFFFFF;
        cursor: pointer;
        margin-right: 28px;
        vertical-align: bottom;
      }

      .text2 {
        display: inline-block;
        width: 136px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        border: 1px solid #2026CC;
        font-size: 16px;
        font-weight: 600;
        color: #2026CC;
        cursor: pointer;
        box-sizing: border-box;
      }
    }
  }

  .box2 {
    .title {
      height: 24px;
      font-size: 16px;
      font-weight: 600;
      color: #333333;
      line-height: 24px;
    }

    .radio {
      margin-top: 32px;

      .name {
        margin-bottom: 20px;
        height: 20px;
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        line-height: 20px;

        span {
          display: inline-block;
          width: 16px;
          height: 16px;
          border: 1px solid #B8B8B8;
          border-radius: 50%;
          margin-right: 8px;
          vertical-align: middle;
          cursor: pointer;
        }

        span.active {
          width: 16px;
          height: 16px;
          border: 1px solid #2026CC;
          position: relative;

          i {
            position: absolute;
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background: #2026CC;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
          }
        }

        a {
          font-size: 14px;
          font-weight: 400;
          color: #2026CC;
          margin-left: 12px;
        }

        input {
          width: 232px;
          height: 36px;
          border: 1px solid #E0E0E0;
          padding-left: 12px;
        }

        input::-webkit-input-placeholder {
          font-size: 13px;
          font-weight: 400;
          color: #666666;
        }
      }
    }

    .title4 {
      margin-top: 60px;

      .text1 {
        display: inline-block;
        width: 136px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        background: #2026CC;
        font-size: 16px;
        font-weight: 600;
        color: #FFFFFF;
        cursor: pointer;
        margin-right: 28px;
        vertical-align: bottom;
      }

      .text2 {
        display: inline-block;
        width: 136px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        border: 1px solid #2026CC;
        font-size: 16px;
        font-weight: 600;
        color: #2026CC;
        cursor: pointer;
        box-sizing: border-box;
      }
    }
  }

  .box3 {
    position: fixed;
    width: 100%;
    height: 100vh;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.4);
    z-index: 999;

    .bussBox {
      width: 380px;
      height: 182px;
      background: #fff;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      padding-top: 28px;

      img {
        width: 50px;
        height: 50px;
      }

      .title1 {
        height: 36px;
        font-size: 24px;
        font-weight: 600;
        color: #333333;
        line-height: 36px;
        margin: 16px 0;
      }

      .title2 {
        height: 21px;
        font-size: 14px;
        font-weight: 400;
        color: #999999;
        line-height: 21px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/my/account/cancel.vue